import React, { useEffect, useState } from 'react';
import styles from './MessageBox.module.css';

const MessageBox = ({ message, type, onClose }) => {
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    // Set a timer to trigger the slide-up animation before actual onClose
    const slideUpTimer = setTimeout(() => {
      setIsExiting(true);
    }, 2500); // Start sliding up 500ms before it's removed (assuming 3000ms total)

    return () => clearTimeout(slideUpTimer);
  }, []);

  if (!message) return null;

  return (
    <div className={`${styles['message-box-container']} ${isExiting ? styles.exit : styles.enter}`}>
      <div className={`${styles['message-box-content']} ${styles[`message-box-${type}`]}`}>
        <p className={styles['message-text']}>{message}</p>
        <button className={styles['close-btn']} onClick={() => {
          setIsExiting(true);
          setTimeout(onClose, 300); // Delay closure for animation
        }}>×</button>
      </div>
    </div>
  );
};

export default MessageBox;
